<template lang="pug">
  .product-slider(ref="productsSlider")
    swiper.slide-area(
      ref="swiper"
      :loop="true"
      :options="swiperOptions"
      :auto-destroy="false"
      :key="swiperSlideKey")
      swiper-slide(v-for="(i, k) in products" :key="k")
        product-card(
          :productCardType="PRODUCT_CARD_TYPES.CATEGORY_CAROUSEL_CATALOG"
          show-variant
          image-path="image_urls.product"
          :data="i"
          :trackProps="{zone: 'CATEGORY_SLIDER_PRODUCTS', position: k}")
    span.slide-previous(v-if="showAction" @click="$refs.swiper.swiperInstance.slidePrev()")
      i.bx.bx-chevron-left.bx-5
    span.slide-next(v-if="showAction" @click="$refs.swiper.swiperInstance.slideNext()")
      i.bx.bx-chevron-right.bx-5
</template>

<script>
import { DEBOUNCE_DELAY, PRODUCT_CARD_TYPES } from '~/settings'
import ProductCard from '~/components/products/ProductCard'

import { Swiper as SwiperClass, Autoplay } from 'swiper/core'
import getAwesomeSwiper from 'vue-awesome-swiper/dist/exporter'
import { debounce } from 'lodash'

SwiperClass.use([Autoplay])
const { Swiper, SwiperSlide } = getAwesomeSwiper(SwiperClass)

const SWIPER_DEFAULT_OPTIONS = {
  autoplay: {
    delay: 3000
  },
  slidesPerView: 4,
  spaceBetween: 10
}

export default {
  name: 'ProductSlider',
  components: {
    ProductCard,
    Swiper,
    SwiperSlide
  },
  props: {
    products: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      PRODUCT_CARD_TYPES,
      swiperSlideKey: 0,
      debouncedResize: null,
      swiperOptions: SWIPER_DEFAULT_OPTIONS,
      showAction: false
    }
  },
  activated () {
    this.resize()
  },
  mounted () {
    this.debouncedResize = debounce(this.resize, DEBOUNCE_DELAY)
    this.$bus.$on('re-render-catalog-recommended-product-swiper-slide', this.debouncedResize)

    window.addEventListener('resize', this.debouncedResize)
    this.resize()
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.debouncedResize)
    this.$bus.$off('re-render-catalog-recommended-product-swiper-slide')
  },
  methods: {
    resize () {
      if (!this.$refs.productsSlider) return

      const isSM = window.innerWidth > 768
      const isLG = window.innerWidth > 1200
      const gap = 10
      const layoutWidth = this.$refs.productsSlider.clientWidth
      const slideWidth = isLG ? 210 : isSM ? 190 : 150
      const slideNum = Math.floor(layoutWidth / (slideWidth + gap))
      this.swiperOptions = { ...SWIPER_DEFAULT_OPTIONS, slidesPerView: slideNum }
      this.showAction = this.products.length > slideNum
      this.swiperSlideKey = Date.now()
    }
  }
}
</script>

<style lang="scss" scoped>
.product-slider {
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  align-items: stretch;
  position: relative;

  @include media(sm) {
    flex-direction: row;
  }

  > * {
    min-width: 0;
  }

  .slide {
    &-area {
      width: 100%;
      transition: opacity .3s ease-in-out;
      &:not(.swiper-container-initialized) {
        opacity: 0;
        display: flex;
        flex-wrap: nowrap;
        height: 410px;
      }
    }
    &-previous, &-next {
      position: absolute;
      border-radius: 50%;
      cursor: pointer;
      width: 28px;
      height: 28px;
      line-height: 28px;
      display: block;
      font-size: 20px;
      text-align: center;
      background-color: white;
      z-index: 1;
      border: $--border-light;
      top: 50%;
      transform: translateY(-50%);
      &:hover {
        font-weight: bold;
      }
    }
    &-previous {
      left: -8px;
      @include media(md) {
        left: -14px;
      }
    }
    &-next {
      right: -8px;
      @include media(md) {
        right: -14px;
      }
    }
  }
}
</style>
